import styled from 'styled-components';

interface IContainerProps {
    marginLeft?: string;
    marginRight?: string;
    marginBottom?: string;
    marginTop?: string;
    width?: string;
    marginLeftMobile?: string;
    marginRightMobile?: string;
    marginBottomMobile?: string;
    marginTopMobile?: string;
    widthMobile?: string;
}

export const Container = styled.div<IContainerProps>`
    display: block;
    width: ${props => props.width || '100%'};
    min-width: ${props => props.width || 'auto'};
    margin-top: ${props => props.marginTop || '10px'};
    margin-bottom: ${props => props.marginBottom || '10px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};

    & label {
        margin: 0px;
        color: #74777A;
        max-height: 22px;
    }

    & .form-control, & .react-datepicker__input-container input {
        color: #74777A;
    }

    & .react-datepicker__input-container input {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        -webkit-appearance: none;
        appearance: none;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    & .form-control:focus, & .react-datepicker__input-container input:focus {
        box-shadow: 0 0 0 0.15rem rgba(var(--bs-primary-rgb), 0.25);
        color: #74777A;
        outline-style: none;
    }

    & .react-datepicker__close-icon::after {
        cursor: pointer;
        color: #888;
        background-color: transparent;
        border-radius: 50%;
        height: 16px;
        width: 16px;
        padding: 2px;
        font-size: 18px;
        line-height: 1;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        content: "×";
    }

    & .react-datepicker__day--outside-month {
        color: #cfd4d9;
    }

    * .react-datepicker-time__header {
        height: 47px;
    }

    @media screen and (max-width: 700px) {
        margin-top: ${props => props.marginTopMobile || props.marginTop || '10px'};
        margin-bottom: ${props => props.marginBottomMobile ||  props.marginBottom || '10px'};
        margin-left: ${props => props.marginLeftMobile || props.marginLeft || '0px'};
        margin-right: ${props => props.marginRightMobile || props.marginRight || '0px'};
        width: ${props => props.widthMobile || props.width || '100%'};
    }
`